import { useCallback, useState } from 'react';

import { MqSwitch } from '@fhs/ui';

import { GiftCardActionSheet } from '../../components/gift-cards-action-sheet';
import { useGiftCardsActionSheet } from '../../components/gift-cards-action-sheet/use-gift-cards-action-sheet';
import { GiftCardsTransactionHistoryActionSheet } from '../../components/gift-cards-transaction-history-action-sheet';
import { useLazyGetGiftCardDataQuery } from '../../queries/use-get-gift-card-data';
import { useGiftCardContext } from '../../state/gift-card';

import { GiftCardsDesktop } from './gift-cards-desktop';
import { GiftCardsMobile } from './gift-cards-mobile';

export function GiftCards() {
  const [showTransactionHistory, setShowTransactionHistory] = useState(false);

  const {
    actionSheetOpen: addGiftCardActionSheetOpen,
    handleActionSheetOpen: handleAddGiftCardActionSheetOpen,
    handleClose: handleAddGiftCardActionSheetClose,
    currentStep: currentAddGiftCardActionSheetStep,
    setCurrentStep: setCurrentAddGiftCardActionSheetStep,
    headerTitle: addGiftCardActionSheetHeaderTitle,
  } = useGiftCardsActionSheet();

  const {
    actionSheetOpen: checkBalanceActionSheetOpen,
    handleActionSheetOpen: handleCheckBalanceActionSheetOpen,
    handleClose: handleCheckBalanceActionSheetClose,
    currentStep: currentCheckBalanceActionSheetStep,
    setCurrentStep: setCurrentCheckBalanceActionSheetStep,
    headerTitle: checkBalanceActionSheetHeaderTitle,
  } = useGiftCardsActionSheet({ isCheckBalanceFlow: true });

  const { lastDigits, isDigitalBalanceLoading, currentBalance, handleBalanceUpdate, handleError } =
    useGiftCardContext();

  const [isCardNumberRedacted, setIsCardNumberRedacted] = useState(true);

  const { query, doQuery: triggerGiftCardDataQuery } = useLazyGetGiftCardDataQuery();
  const cardDataLoading = query.isLoading || query.isFetching;
  const cardNumber = query.data?.giftCardData?.cardNumber;
  const pin = query.data?.giftCardData?.pin;

  const onPressShowCardNumber = useCallback(async () => {
    triggerGiftCardDataQuery();
    setIsCardNumberRedacted(redacted => !redacted);
  }, [triggerGiftCardDataQuery]);

  return (
    <>
      <MqSwitch
        $ltDesktop={() => (
          <GiftCardsMobile
            onAddGiftCardPress={handleAddGiftCardActionSheetOpen}
            onCheckBalancePress={handleCheckBalanceActionSheetOpen}
            lastDigits={lastDigits}
            onPressShowCardNumber={onPressShowCardNumber}
            isCardNumberRedacted={isCardNumberRedacted}
            isCardNumberLoading={cardDataLoading}
            cardNumber={cardNumber}
            pin={pin}
            onSeeHistoryPress={() => setShowTransactionHistory(true)}
            isDigitalBalanceLoading={isDigitalBalanceLoading}
          />
        )}
        $gteDesktop={() => (
          <GiftCardsDesktop
            onAddGiftCardPress={handleAddGiftCardActionSheetOpen}
            onCheckBalancePress={handleCheckBalanceActionSheetOpen}
            lastDigits={lastDigits}
            onPressShowCardNumber={onPressShowCardNumber}
            isCardNumberRedacted={isCardNumberRedacted}
            isCardNumberLoading={cardDataLoading}
            cardNumber={cardNumber}
            pin={pin}
            onSeeHistoryPress={() => setShowTransactionHistory(true)}
            isDigitalBalanceLoading={isDigitalBalanceLoading}
          />
        )}
      />
      {addGiftCardActionSheetOpen && (
        <GiftCardActionSheet
          headerTitle={addGiftCardActionSheetHeaderTitle}
          isVisible
          currentStep={currentAddGiftCardActionSheetStep}
          currentDigitalBalance={currentBalance}
          handleBalanceUpdate={handleBalanceUpdate}
          handleError={handleError}
          setCurrentStep={setCurrentAddGiftCardActionSheetStep}
          onClose={handleAddGiftCardActionSheetClose}
        />
      )}
      {checkBalanceActionSheetOpen && (
        <GiftCardActionSheet
          headerTitle={checkBalanceActionSheetHeaderTitle}
          isVisible
          isCheckBalanceFlow
          currentStep={currentCheckBalanceActionSheetStep}
          currentDigitalBalance={currentBalance}
          handleBalanceUpdate={handleBalanceUpdate}
          handleError={handleError}
          setCurrentStep={setCurrentCheckBalanceActionSheetStep}
          onClose={handleCheckBalanceActionSheetClose}
        />
      )}
      {showTransactionHistory && (
        <GiftCardsTransactionHistoryActionSheet
          isVisible
          onClose={() => setShowTransactionHistory(false)}
        />
      )}
    </>
  );
}
